module.exports = __webpack_public_path__ + "ddbd1d9b113b2688102f56c63a431475.svg";